// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--2Hhyi"};